import styled from 'styled-components';

export const Outer = styled.div<{ selected: boolean }>`
  position: absolute;
  width: ${({ theme }) => theme.x2spacePx}px;
  height: ${({ theme }) => theme.x2spacePx}px;
  border-radius: 50%;
  border: 1px solid
    ${({ theme, selected }) =>
      selected ? theme.color.brand01 : theme.color.whiteRGBA(0.1)};
`;
